import { Component, OnInit, Input, ViewChild, ElementRef } from "@angular/core";
import { UserModel } from "../../models/user/user.model";
import { AuthService } from "../../services/auth.service";
import { BrogliacciService } from "../../services/brogliacci.service";
import { DistinteIncassiService } from "../../services/distinte-incassi.service";
import { LangService } from "../../services/lang.services";
import { UltimaVersioneApplicativoClientService } from "../../services/ultima-versione-applicativo-client.service";
import { DashboardService } from "../../services/dashboard.service";
import { BloccoModel } from "../../models/dashboard/blocco.model";
import { Configurations } from "../../core/configurations";
import {
  MdDialog,
  MdDialogConfig,
  MdSelect,
  MdSnackBar,
} from "@angular/material";
import { DialogCloseAskerComponent } from "../dialog-close-asker/dialog-close-asker.component";
import { ManageSliderComponent } from "./manager-slider/manage-slider.component";
import { SliderModel } from "../../models/dashboard/slider.model";
import { SharedService } from "../../services/shared.service";

import * as _ from "lodash";
import { ItemManagerComponent } from "../utils/item-manager/item-manager.component";
import { ItemSliderManagerComponent } from "../utils/item-slider-manager/item-slider-manager.component";
import { BloccoTipoModel } from "../../models/dashboard/bloccoTipo.model";
@Component({
  selector: "app-homepage-manager",
  templateUrl: "./homepage-manager.component.html",
  styleUrls: ["./homepage-manager.component.css"],
})
export class HomepageManagerComponent implements OnInit {
  user: UserModel;
  isLoading: boolean;
  published: boolean = false;

  webView: boolean;

  @ViewChild("droppableDiv") droppableDiv: ElementRef;

  constructor(
    public _authService: AuthService,
    private _langService: LangService,
    private _ultimaVersioneClientTipo: UltimaVersioneApplicativoClientService,
    private _dashboardService: DashboardService,
    private _sharedService: SharedService,
    private dialog: MdDialog,
    private snackBar: MdSnackBar
  ) {
    this.user = this._authService.user;
    this.webView = window.innerWidth > 768 ? true : false;
  }

  isInAnteprima = false;
  size: any;
  dashboardContent: Array<BloccoModel> = [];
  dashboardContentFiltered: Array<BloccoModel> = [];
  ruoli: Array<{ id: number; name: string }>;
  businessLines: Array<{ id: number; codice: string }>;
  rowHeight = "200px";
  slider: SliderModel;
  ruoloFilter:number;
  businessLineFilter:number;

  ngOnInit() {
    this._langService.setLang("it");
    this.getHomepageData();
    this._ultimaVersioneClientTipo
      .getUltimaVersioneApplicativo()
      .subscribe((data) => {
        Configurations.currentVersionCod = data.codice;
        let v = localStorage.getItem("clientVersion");
        if (v === null || v === undefined || v !== data.codice) {
          localStorage.setItem("clientVersion", data.codice);
          alert(
            "Sono state pubblicate delle modifiche nel portale, per poterle caricare verrà indirizzato alla homepage."
          );
          window.location.href = Configurations.baseUrl;
        }
      });
    this._dashboardService.getBloccoTipi().subscribe(
      (result) => {
        this._sharedService.setTipi(result);
      },
      (err) => {}
    );
  }

  hasPermission(permName: string) {
    return this._authService.isGranted(permName);
  }

  onResize() {
    this.resizeGrid();
  }

  resizeGrid = (width?) => {
    const widthForCheck = width && !isNaN(width) ? width : window.innerWidth;

    this.dashboardContentFiltered.forEach((item) => {
      if (widthForCheck > 768) {
        item.cols = item.colonneBlocco;
      }
      if (widthForCheck > 425 && widthForCheck <= 768) {
        item.cols =
          item.colonneBlocco >= this.size / 2
            ? this.size
            : Math.ceil(this.size / 2);
      }
      if (widthForCheck <= 425) {
        item.cols = this.size;
      }
    });
  };

  addItem() {
    const options: MdDialogConfig = {
      hasBackdrop: true,
      disableClose: true,
      width: "750px",
    };

    const dialogRef = this.dialog.open(ItemManagerComponent, options);

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getHomepageData();
      }
    });
  }

  manageBlocks() {
    const options: MdDialogConfig = {
      hasBackdrop: true,
      disableClose: true,
      width: "500px",
    };

    const dialogRef = this.dialog.open(ItemSliderManagerComponent, options);

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (result.editBlocco) {
          this.manageItem({
            ...result.blocco,
            idBlocco: result.idBlocco,
            tipoBlocco: result.blocco.tipo.codice,
          });
        } else {
          this.getHomepageData();
        }
      }
    });
  }

  deleteItem(event, itemToDelete: BloccoModel) {
    event.preventDefault();
    event.stopPropagation();
    const options: MdDialogConfig = {
      hasBackdrop: true,
      disableClose: true,
      data: {
        title: "Vuoi davvero cancellare questo blocco?",
        subtitle: "Questa azione non è reversibile!",
      },
      width: "500px",
    };

    const dialogRef = this.dialog.open(DialogCloseAskerComponent, options);

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        const deleteBlocco = {
          id: itemToDelete.idBlocco,
          token: itemToDelete.token,
          codiceBloccoTipo: itemToDelete.tipoBlocco,
        };
        this._dashboardService
          .deleteBloccoSlider(itemToDelete.idBloccoSlider)
          .subscribe(
            (res) => {
              this._dashboardService.deleteBlocco(deleteBlocco).subscribe(
                (deleteBloccoRes) => {
                  if (deleteBloccoRes) {
                    this.getHomepageData();
                  }
                },
                (err) => {}
              );
            },
            (err) => {}
          );
      }
    });
  }

  manageItem(item) {
    this.isLoading = true;
    this._dashboardService.getBloccoSlider(item.token).subscribe(
      (data) => {
        item = { ...item, ...data };
        this._sharedService.setBlocco(item);
        this.isLoading = false;
        const options: MdDialogConfig = {
          data: { ...item },
          hasBackdrop: true,
          disableClose: true,
          width: "750px",
        };

        const dialogRef = this.dialog.open(ItemManagerComponent, options);

        dialogRef.afterClosed().subscribe((result) => {
          if (result) {
            if (result.order !== item.ordine) {
              //Edit blocco slider
              const bloccoToSlider = {
                idBlocco: item.idBlocco,
                idSlider: this._sharedService.getSlider().id,
                ordineBlocco: result.order,
                dataInizio: new Date().toISOString(),
              };
              this.editBloccoToSlider(bloccoToSlider);
            }
            this.getHomepageData();
          }
        });
      },
      (error) => {
        this.isLoading = false;
      }
    );
  }

  setView(type?: string) {
    const width = !type ? "auto" : type === "tablet" ? "768" : "425";
    document
      .getElementById("appDynamiComponents")
      .setAttribute("style", `width: ${width}px`);
    const widthForControl = document.getElementById("appDynamiComponents").style
      .width;
    this.resizeGrid(width);
  }


  filterData = () => {
    this.dashboardContentFiltered = this.dashboardContent.filter((item) => {
      if (item.authManItems) {
        return (
          item.authManItems.length === 0 ||
          !this.ruoloFilter ||
          item.authManItems.find(
            (authItem) => authItem.idAuthManItems === this.ruoloFilter
          )
        );
      }
      return false;
    }).filter((item) => {
      if (item.businessLines) {
        console.log(item.businessLines);
        console.log(this.businessLineFilter);
        return (
          item.businessLines.length === 0 ||
          !this.businessLineFilter || 
          item.businessLines.find(
            (bl) => bl.idBusinessLine === this.businessLineFilter
          )
        );
      }
      return false;
    }).filter((item) => {
      return (
        this.published ? 
        item.pubblicato &&
        (item.dataInizio ? new Date() > new Date(item.dataInizio) : true) &&
        (item.dataFine ? new Date() < new Date(item.dataFine) : true) : true
      );
    });

    this.resizeGrid();
  }

  filterByRuolo = (ruolo?: number) => {
      this.ruoloFilter = ruolo;
      this.filterData();
    }
    
    filterByBusinbessLine = (businessLine?: number) => {
      this.businessLineFilter = businessLine;
      this.filterData();
    }
    
    filterByStatus(isPublished) {
      this.published = isPublished;
      this.filterData();
  }

  manageSlider() {
    const options: MdDialogConfig = {
      hasBackdrop: true,
      disableClose: true,
      width: "500px",
      data: {
        sliderToken: this.slider.token,
      },
    };

    const dialogRef = this.dialog.open(ManageSliderComponent, options);

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (result.slider) {
          this._dashboardService.updateSlider(result.slider).subscribe(
            (res) => {
              this.getHomepageData();
            },
            (err) => {
              this.showError("Something went wrong");
            }
          );
        }
      }
    });
  }

  getHomepageData() {
    this.isLoading = true;
    this._dashboardService.getSliders().subscribe((slider) => {
      const currentSlider = slider.find(
        (page) => page.nomeSlider === "Homepage"
      );
      this._dashboardService.getAuthManItems().subscribe((ruoli) => {
        this.ruoli = [
          {
            id: null,
            name: "Reset",
          },
          ...ruoli,
        ];
        this.manageDashboardContent(currentSlider);
      });

      this._dashboardService.getAllBusinessLines().subscribe(data => {
        this.businessLines = [
          {
            id: null,
            codice: "Reset",
          },
          ...data
        ];
      })
    });
  }

  private manageDashboardContent(currentSlider: SliderModel) {
    this._dashboardService
      .getSlider(currentSlider.token, true)
      .finally(() => (this.isLoading = false))
      .subscribe((homepageSlider) => {
        this.dashboardContent = _.orderBy(homepageSlider.blocchiInfo, [
          "ordine",
        ]);
        this.dashboardContentFiltered = [...this.dashboardContent];
        this.size = homepageSlider.colonneSlider;
        this.rowHeight = `${homepageSlider.righeSlider}px`;
        this.slider = homepageSlider;
        this._sharedService.setSlider(homepageSlider);
        // this.filterByRuolo();
        this.filterData();
        this.isLoading = false;
      });
  }

  drop(ev) {
    ev.preventDefault();
    let data = ev.dataTransfer.getData("text");
    ev.target.classList.remove("highlight");
    const item = this.getClosest(ev.target, ".draggable-item");
    if (item) {
      //add before this one
      const elementToMove = this.getItemData(data);
      const elementToReplace = this.getItemData(item.id);
      const bloccoToSlider = {
        idBlocco: elementToMove.idBlocco,
        idSlider: this._sharedService.getSlider().id,
        ordineBlocco: elementToReplace.ordine,
        dataInizio: new Date().toISOString(),
      };

      this.editBloccoToSlider(bloccoToSlider);
    } else {
      const elementToMove = this.getItemData(data);
      // add to the last
      const bloccoToSlider = {
        idBlocco: elementToMove.idBlocco,
        idSlider: this._sharedService.getSlider().id,
        ordineBlocco: this._sharedService.getSlider().blocchiInfo.length - 1,
        dataInizio: new Date().toISOString(),
      };

      this.editBloccoToSlider(bloccoToSlider);
    }
    // let index = ev.target.childNodes[0].childNodes.findIndex(document.getElementById(data));
  }

  getClosest = (elem, selector) => {
    if (elem.matches) {
      if (elem.matches(selector)) {
        return elem;
      }
      return this.getClosest(elem.parentNode, selector);
    }
    return null;
  };

  private editBloccoToSlider(bloccoToSlider: {
    idBlocco: any;
    idSlider: number;
    ordineBlocco: number;
    dataInizio: string;
  }) {
    this._dashboardService
      .editBloccoToSlider(bloccoToSlider)
      .subscribe((sliderRes) => {
        this.manageDashboardContent(this.slider);
      });
  }

  getItemData(itemId) {
    const items = itemId.split("-");
    return {
      idBlocco: items[1],
      ordine: items[2],
    };
  }

  allowDrop(ev) {
    ev.preventDefault();
    const item = this.getClosest(ev.target, ".draggable-item");
    if (item) {
      item.classList.add("highlight");
    } else {
      ev.target.classList.add("highlight");
    }
  }

  removeHighlight(ev) {
    ev.preventDefault();

    const item = this.getClosest(ev.target, ".draggable-item");
    if (item) {
      item.classList.remove("highlight");
    } else {
      ev.target.classList.remove("highlight");
    }
  }

  drag(ev) {
    ev.dataTransfer.setData("text", ev.target.id);
  }

  private showError(message: string) {
    this.snackBar.open("Errore: " + message, "Chiudi", { duration: 5000 });
  }
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/homepage-manager/homepage-manager.component.ts